import appconf from "./appconf.js"
const domain = appconf.domain;
export default {
	Domain: domain, // 服务器地址

	OurUpLoadUrl:  "https://jkht.wteam.club",
	// OurUpLoadUrl:  "https://jkht.wteam.club",
	// OurUpLoadUrl:  "https://cwadmin.tmmbuy.com",
	OurUpLoadUrl1: "https://jkht.wteam.club",
  OurUpLoadUrl3:  "https://cwadmin.tmmbuy.com",
  OurUpLoadUrl4:  "https://adminbg.czsgaf.com",

	ZheKeUploadUrl: "https://admin.51sioc.com",


	NotActionLogin: domain + "tcstore/wx/login/silence", // 静默登录（微信）

	login: domain + "/business/login",

	CameraDevice: "/devicelog/access/CameraDevice", // 查询门店监控数据
	CameraUserDevice:"/devicelog/access", // 查询某用户全部进门记录
	CameraDeviceList: "/devicelog/access/list", // 查询门禁进出日记列表
	orderById: "/order", // 查询订单详情

	classificationStatistics:domain + "/storeSalesAnalysis/classificationStatistics",  // 分类统计
	classificationTime:domain + "/storeSalesAnalysis/classificationTime",  // 分时统计
	Statistics: "/storeSalesAnalysis/Statistics",  // 数据统计

}



// WEBPACK FOOTER //
// ./src/common/api.js